<template>
  <el-dialog :title="getTitle()" :visible.sync="show" width="80%" custom-class="model-select-dialog" append-to-body v-loading="loading">
    <div v-show="step === 1">
      <div class="app-toolbar2">
        <el-input size="small" placeholder="请输入名称或描述中的关键字" v-model="query.keyword" clearable style="width:320px">
          <el-button slot="append" size="small" icon="el-icon-search" @click="load(1)">查询</el-button>
        </el-input>
      </div>
      <el-table :data="models" @current-change="select" @row-dblclick="selectAndNext" :stripe="true" size="mini" highlight-current-row ref="modelTable">
        <el-table-column prop="modelId" label="ID" width="60"></el-table-column>
        <el-table-column prop="projectName" label="所属项目"></el-table-column>
        <el-table-column prop="systemName" label="所属后端系统"></el-table-column>
        <el-table-column prop="type" label="类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 'OBJECT'">单一对象</span>
            <span v-if="scope.row.type === 'LIST'">列表</span>
            <span v-if="scope.row.type === 'PAGE'">分页</span>
            <span v-if="scope.row.type === 'FIELD'">单个字段</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="acType" label="访问控制类型" width="92">
          <template slot-scope="scope">
            <span v-if="scope.row.acType === acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="updateTime" label="最后更新时间" width="140"></el-table-column>
      </el-table>
      <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>
    </div>
    <el-table v-show="step === 2" :data="columns" row-key="columnLabel" :stripe="true" size="mini" ref="columnTable">
      <el-table-column type="selection" width="30"></el-table-column>
      <el-table-column prop="orderNo" label="顺序" width="140">
        <template slot-scope="scope">
          <el-input-number placeholder="请输入该列顺序" v-model="scope.row.orderNo" size="mini" :min="1" @change="reorderColumns"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="width" label="列宽" width="160">
        <template slot-scope="scope">
          <el-input placeholder="请输入该列所占宽度" v-model="scope.row.width" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="newline" label="是否换行(默认换行)" width="145">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.newline" size="mini">
            <el-radio-button label="1">换行</el-radio-button>
            <el-radio-button label="0">不换行</el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column prop="displayName" label="展示名称">
        <template slot-scope="scope">
          <el-input placeholder="请输入展示名称" v-model="scope.row.displayName" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="columnLabel" label="字段" width="180px"></el-table-column>
      <el-table-column prop="cmt" label="注释"></el-table-column>
      <el-table-column prop="columnTypeName" label="数据库类型" width="180px"></el-table-column>
      <el-table-column prop="columnClassName" label="JAVA类型" width="180px"></el-table-column>
    </el-table>
    <el-table v-show="step === 3" :data="conditions" :stripe="true" size="mini">
      <el-table-column label="数据库表中的列，多个列用英文逗号隔开">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.column"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="运算符">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.operator" style="width:100%;">
            <el-option v-for="o in operators" :key="o.value" :value="o.value" :label="o.label"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="页面控件ID或表达式">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.relateComponentId"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="值处理函数">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.valueProcessFn" clearable>
            <el-option v-for="valueProcess in valueProcesses" :key="valueProcess.name" :value="valueProcess.name" :label="valueProcess.desc"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteCondition(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form v-if="step === 4" :status-icon="true" label-width="140px" style="margin:20px auto;width:60%;">
      <el-form-item label="数据的ID字段名">
        <el-input v-model="operations.idColumnName" placeholder="请输入数据的ID字段名" :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="更新页面ID" v-if="device === 'MOBILE'">
        <el-input-number v-model="operations.updatePageId" placeholder="请输入更新页面ID" style="width:100%"></el-input-number>
      </el-form-item>
      <el-form-item label="更新对话框ID" v-if="device === 'PC'">
        <el-input v-model="operations.updateDialogId" placeholder="请输入更新对话框ID" style="width:100%"></el-input>
      </el-form-item>
      <el-form-item label="删除API">
        <el-input v-model="operations.deleteApi" placeholder="请输入删除API的地址"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" type="primary" @click="addCondition" v-show="step === 3" style="float:left">添加条件</el-button>
      <el-button size="mini" @click="showTip = true" v-show="step === 3 || step === 4" style="float:left">查看说明</el-button>
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="gotoStep(false)" v-show="step > 1">上一步</el-button>
      <el-button size="mini" type="primary" @click="gotoStep(true)" v-show="(configColumn1 && step < 2) || (configCondition && step < 3) || (configOperation && step < 4)" :disabled="!selected">下一步</el-button>
      <el-button size="mini" type="primary" @click="doSave" v-show="(step === 4) || (step === 3 && !configOperation) || (step === 2 && !configCondition && !configOperation) || (step === 1 && !configColumn1 && !configCondition && !configOperation)" :disabled="!selected">确 定</el-button>
    </div>

    <el-dialog title="说明" :visible.sync="showTip" width="80%" append-to-body>
      <div class="pc-select-dialog-tip" v-show="step === 3">
        <h3>什么是页面控件ID或表达式？</h3>
        <p>这里的“页面控件ID”是指，在当前页面上的某一个组件的ID。通过该ID，系统会自动找到该控件，并以其值作为查询条件的值。“表达式”为参数“param”或“account”的属性，写法例：“account.gridCode”</p>
      </div>
      <div class="pc-select-dialog-tip" v-show="step === 4">
        <h3>什么是更新页面ID？</h3>
        <p>如果当前被配置(数据源)的组件是一个列表，比如手机端的滚动分页列表，或者电脑端的分页列表，它们通常都会配备更新和删除的功能。而“更新页面”就是用于更新数据的页面，通过填写其ID，列表组件会自动添加更新按钮，点击该按钮就可以打开更新页面。</p>
        <h3>如果我不需要更新操作怎么办？</h3>
        <p>那就把“更新页面ID”空着，什么也不要填写。</p>
        <h3>什么是默认的删除API？</h3>
        <p>系统为动态表单提供了内置的数据维护接口，包括新增、更新、删除和查询。所以使用动态表单作为数据源的列表，可以使用动态表单的“默认删除API”，选中后，列表组件就会自动添加删除按钮了。</p>
        <h3>如果我有自定义的删除API，不想使用默认的删除API该怎么办？</h3>
        <p>那就不要选中“默认的删除API”，然后将你的自定义API填写在“删除API”中就可以了。</p>
        <p>但是请一定要记住，自定义删除接口必须遵循Restful规则：以DELETE作为请求方法；请求地址代表了被删除的数据。</p>
        <p>比如：http://www.demo.com/api/v1/dogs/，“www.demo.com”是API的域名，“/api”是API的标识，“/v1”是API的版本，“/dogs”代表了“狗”这种资源。</p>
        <p>系统按照Restful规则，在地址后面拼接上被用户删除的那条狗的ID，形成如下地址“http://www.demo.com/api/v1/dogs/1”，并以DELETE方法请求该地址。</p>
        <h3>如果我不需要删除操作怎么办？</h3>
        <p>那就不要选中“默认的删除API”，也不要填写“删除API”。</p>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { acTypes } from '@/config'
import { getDevice } from '../util.js'

export default {
  name: 'model-select-dialog',
  props: {
    endpoint: { type: String, required: true },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false, default: false },
    configCondition: { type: Boolean, required: false, default: false },
    configOperation: { type: Boolean, required: false, default: false }
  },
  computed: {
    configColumn1: function () {
      return this.configColumn && this.dataType !== 'FIELD'
    }
  },
  data () {
    return {
      acTypes: acTypes,
      device: '',
      model: {},
      show: false,
      step: 0,
      loading: false,
      query: {
        page: 1,
        limit: 10,
        total: 0,
        keyword: ''
      },
      models: [],
      selected: null,
      modelIdOfColumns: null,
      columns: null,
      conditions: null,
      operations: null,
      operators: [
        { value: '=', label: '等于', type: 'single' },
        { value: 'LIKE', label: '模糊查询', type: 'single' },
        { value: '>', label: '大于', type: 'single' },
        { value: '<', label: '小于', type: 'single' },
        { value: '>=', label: '大于等于', type: 'single' },
        { value: '<=', label: '小于等于', type: 'single' },
        { value: '<>', label: '不等于', type: 'single' },
        { value: 'IN', label: 'IN', type: 'range' },
        { value: 'NOT IN', label: 'NOT IN', type: 'range' },
        { value: 'IS NOT NULL', label: '不为空', type: 'none' },
        { value: 'IS NULL', label: '为空', type: 'none' }
      ],
      valueProcesses: [],
      showTip: false
    }
  },
  created () {
    this.device = getDevice(this.endpoint)
  },
  watch: {
    step (val) {
      let me = this
      if (val === 2) {
        if (me.modelIdOfColumns === me.selected.modelId) {
          return
        }

        me.loading = true
        me.$http.request({
          method: 'get',
          url: `/api/cgModels/${me.selected.modelId}/metadata`
        }).then((res) => {
          me.loading = false
          if (!res.data.data) {
            return
          }

          let metadata = res.data.data
          let columnCmtMap = {}
          if (metadata.config) {
            let tables = JSON.parse(metadata.config).tables || []
            for (let table of tables) {
              let columns = table.columns || []
              for (let column of columns) {
                columnCmtMap[column.alias] = column.cmt
              }
            }
          }

          let columns = metadata.sqlColumnMetas || []
          for (let column of columns) {
            column.cmt = columnCmtMap[column.columnLabel]
            column.displayName = column.cmt || ''
          }

          let temp = []
          let arr = []
          let currentOrderNo = 1
          let selectedColumns = me.model.columns || []
          for (let selectedColumn of selectedColumns) {
            for (let column of columns) {
              if (selectedColumn.name === column.columnLabel) {
                column.displayName = selectedColumn.displayName
                column.width = selectedColumn.width
                column.newline = selectedColumn.newline
                column.orderNo = currentOrderNo++
                temp.push(column)
                arr.push(column)
                break
              }
            }
          }

          for (let column of columns) {
            if (column.orderNo === undefined) {
              column.orderNo = currentOrderNo++
              arr.push(column)
            }
          }
          columns = arr

          me.modelIdOfColumns = me.selected.modelId
          me.columns = columns

          if (me.selected.modelId === me.model.id) {
            me.model.columns = null
            if (temp.length) {
              me.$nextTick(() => {
                temp.forEach(row => {
                  me.$refs.columnTable.toggleRowSelection(row, true)
                })
              })
            }
          }
        }).catch(() => {
          me.loading = false
        })
      } else if (val === 3) {
        if (me.conditions) {
          return
        }
        let conditions
        if (me.selected.modelId === me.model.id && me.model.conditions) {
          conditions = me.model.conditions
          me.model.conditions = null
        } else {
          conditions = [{}]
        }
        me.conditions = conditions

        if (!me.valueProcesses || !me.valueProcesses.length) {
          me.$http.request({
            method: 'get',
            url: '/api/cgValueProcesses'
          }).then((res) => {
            me.valueProcesses = res.data.data
          })
        }
      } else if (val === 4) {
        if (me.operations) {
          return
        }
        let operations
        if (me.selected.modelId === me.model.id && me.model.operations) {
          operations = me.model.operations
          me.model.operations = null
        } else {
          operations = {}
        }
        me.operations = operations
      }
    }
  },
  methods: {
    getTitle () {
      if (this.step === 1) {
        return '选择模型'
      }
      if (this.step === 2) {
        return '配置要展示的列'
      }
      if (this.step === 3) {
        return '配置查询条件'
      }
      if (this.step === 4) {
        return '配置更新与删除'
      }
    },
    open (value) {
      this.model = value ? JSON.parse(value) : {}
      this.query.keyword = ''
      this.modelIdOfColumns = null
      this.columns = null
      this.conditions = null
      this.operations = null
      this.load(1, this.model.id)
      this.step = 1
      this.show = true
    },
    load (page, modelId) {
      let url = `/api/cgModels?keyword=${this.query.keyword}&page=${page}&limit=${this.query.limit}`
      if (modelId) {
        url = `${url}&modelId=${modelId}`
      }
      if (this.dataType) {
        url = `${url}&type=${this.dataType}`
      }

      this.loading = true
      this.$http.request({
        method: 'get',
        url: url
      }).then((res) => {
        let pageData = res.data.data
        this.models = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false

        if (modelId && this.models.length) {
          this.$refs.modelTable.setCurrentRow(this.models[0])
        } else {
          this.$refs.modelTable.setCurrentRow()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    select (row) {
      this.selected = row || null
    },
    selectAndNext (row) {
      this.selected = row || null
      if (this.selected) {
        if (!this.configColumn1 && !this.configCondition) {
          this.doSave()
        } else {
          this.gotoStep(true)
        }
      }
    },
    gotoStep (forward) {
      let result = this.step
      let step = this.step
      if (forward) {
        if (step === 1) {
          if (this.configColumn1) {
            result = 2
          } else if (this.configCondition) {
            result = 3
          } else if (this.configOperation) {
            result = 4
          }
        } else if (step === 2) {
          if (this.configCondition) {
            result = 3
          } else if (this.configOperation) {
            result = 4
          }
        } else if (step === 3) {
          if (this.configOperation) {
            result = 4
          }
        }
      } else {
        if (step === 4) {
          if (this.configCondition) {
            result = 3
          } else if (this.configColumn1) {
            result = 2
          } else {
            result = 1
          }
        } else if (step === 3) {
          if (this.configColumn1) {
            result = 2
          } else {
            result = 1
          }
        } else if (step === 2) {
          result = 1
        }
      }
      this.step = result
    },
    reorderColumns () {
      this.columns = this.columns.sort((c1, c2) => {
        if (c1.orderNo === undefined && c2.orderNo === undefined) {
          return 0
        }
        if (c1.orderNo === undefined && c2.orderNo !== undefined) {
          return 1
        }
        if (c1.orderNo !== undefined && c2.orderNo === undefined) {
          return -1
        }
        return c1.orderNo - c2.orderNo
      })
    },
    addCondition () {
      this.conditions.push({})
    },
    deleteCondition (index) {
      this.conditions.splice(index, 1)
    },
    doSave () {
      let columns = []
      if (this.configColumn1) {
        let selection = this.$refs.columnTable.selection
        if (!selection || !selection.length) {
          alert('请选择要展示的列')
          return
        }

        for (let column of selection) {
          columns.push({
            name: column.columnLabel,
            displayName: column.displayName,
            width: column.width,
            newline: column.newline,
            display: true,
            orderNo: column.orderNo
          })
        }

        columns = columns.sort(function (c1, c2) {
          return c1.orderNo - c2.orderNo
        })

        for (let column of columns) {
          delete column.orderNo
        }
      }

      let conditions = []
      if (this.configCondition) {
        for (let condition of this.conditions) {
          let hasOwnProperty = false
          for (let f in condition) {
            if (condition.hasOwnProperty(f)) {
              hasOwnProperty = true
              break
            }
          }

          if (hasOwnProperty) {
            conditions.push(condition)
          }
        }
      }

      let operations = null
      if (this.operations) {
        for (let f in this.operations) {
          if (this.operations.hasOwnProperty(f)) {
            operations = this.operations
            break
          }
        }
      }

      let data = { type: 'model', id: this.selected.modelId, name: this.selected.name, dataType: this.selected.type }
      if (columns.length) {
        data.columns = columns
      }
      if (conditions.length) {
        data.conditions = conditions
      }
      if (operations) {
        data.operations = operations
      }
      this.$emit('save', data)
      this.show = false
    }
  }
}
</script>

<style>
.model-select-dialog .el-dialog__body{padding:0;margin-top:10px;border-top:1px solid #ebeef5;}
</style>
